import { CoreEnums } from '@/utils/domain/constants';
import _ from 'lodash';

const { FormFieldType, FormFieldBehavior, FormFieldStringType } = CoreEnums;

const APPEARANCE_TYPES = {
  FILL_READ: 'fill-read',
};

const createRulesConfig = (required) => [{ required }];

const isLocationField = (fieldType) => {
  return fieldType === FormFieldType.Location || fieldType === FormFieldStringType.Location;
};

const getReadOnlyBehavior = (field) => ({
  readOnly: true,
  disabled: true,
  appearance: APPEARANCE_TYPES.FILL_READ,
  ...(!field?.shouldUpdate && {
    rules: createRulesConfig(isLocationField(field?.type) ? field?.required : false),
  }),
});

const getLockedBehavior = () => ({
  readOnly: true,
  disabled: true,
  isLocked: true,
  appearance: APPEARANCE_TYPES.FILL_READ,
  rules: createRulesConfig(false),
  style: { pointerEvents: 'none' },
  visibilityToggle: false,
  shouldUpdate: false,
  ariaDisabled: true,
  ariaReadonly: true,
});

export function getFieldInitialBehavior(field = {}) {
  const behaviorMap = {
    [FormFieldBehavior.ReadOnly]: () => getReadOnlyBehavior(field),
    [FormFieldBehavior.Hidden]: () => ({ hidden: true, rules: createRulesConfig(false) }),
    [FormFieldBehavior.Required]: () => ({ rules: createRulesConfig(true) }),
    [FormFieldBehavior.NotRequired]: () => ({ rules: createRulesConfig(false) }),
    [FormFieldBehavior.Locked]: getLockedBehavior,
  };

  const behaviorHandler = behaviorMap[field?.fieldBehavior];
  return behaviorHandler ? behaviorHandler() : {};
}

export const hasValidConditions = (behaviorCase) => {
  return (
    behaviorCase.conditionGroups?.length > 0 &&
    _.some(behaviorCase.conditionGroups, (cg) => cg.conditions?.length > 0)
  );
};

export function behaviorCasesByField(field, behaviorCases = []) {
  return _.filter(
    behaviorCases,
    (behaviorCase) => field?.id === behaviorCase.field?.id && hasValidConditions(behaviorCase),
  );
}

export const findApplicableBehavior = (behaviors) => {
  if (behaviors.length === 0) return null;
  if (behaviors.length === 1) {
    return _.head(behaviors);
  }

  return (
    _.find(
      behaviors,
      (behaviorCase) =>
        !behaviorCase.conditionGroups?.length &&
        _.every(behaviorCase.conditionGroups, (cg) => !cg.conditions?.length),
    ) || _.head(behaviors)
  );
};

export const createBehaviorConfig = (field, behaviorCases, isLocked, shouldUpdate) => {
  if (isLocked || !shouldUpdate) return {};

  return {
    shouldUpdate: true,
    behaviorCases: behaviorCasesByField(field, behaviorCases),
  };
};

export { APPEARANCE_TYPES };
